

// Verify whether the label requested exists within the label object 
const verifyLabel = (requestedLabel, labelsObj) => {
const doesExist = Object
    .keys(labelsObj && typeof labelsObj === "object" ? labelsObj : {})
    .find(label => label === requestedLabel)

    if(!doesExist){
      console.error('Missing Label:',requestedLabel, 'missing from collection:',labelsObj)
    }
    
  return doesExist && labelsObj[requestedLabel] ? labelsObj[requestedLabel] : requestedLabel
}


export default verifyLabel

